import {Routes} from "react-router";
import {Route, useLocation} from "react-router-dom";
import React from "react";
import {Settings} from "./Settings";
import {DebugSettings} from "./DebugSettings";
import {Membership} from "./Membership";
import {isProduction} from "../../../../util/HostUtils";

export const useSettingsTabs = () => {

  const location = useLocation();

  const general = {label: 'General', link: '..', isSelected: location.pathname == '/home/settings'};
  const membership = {label: 'Membership', link: '../membership', isSelected: location.pathname == '/home/settings/membership'}
  const debug = {label: 'Debug Settings', link: '../debug', isSelected: location.pathname == '/home/settings/debug'}

  return isProduction() ? [general,  membership] : [general, membership, debug];

}

export const SettingsRouter = () => {
  return <div className={'NonScrollingToolPage'}>

    <Routes>
      <Route path='/membership' element={<Membership/>}/>

      {!isProduction() && <Route path='/debug' element={<DebugSettings/>}/>}

      <Route path="/" element={<Settings/>}/>
    </Routes>
  </div>
}